import React, { FunctionComponent } from 'react';
import { Box, Text } from 'rebass/styled-components';

export interface PolicyListHeaderProps {
  reorderButtons: React.ReactElement;
  isPoliciesLength: boolean;
  isSearchInput: boolean;
  isEditing: boolean;
  isFetchingPolicies: boolean;
}

const PolicyListHeader: FunctionComponent<PolicyListHeaderProps> = ({
  reorderButtons, isPoliciesLength, isSearchInput,
  isEditing, isFetchingPolicies,
}: PolicyListHeaderProps) => {
  // If we are searching and have policies, just show text header
  if (isSearchInput) {
    return (
      <Text height="32px" fontWeight="bold" fontSize={3} p={1} color="white">Search Results</Text>
    );
  }

  // If we are not editing and there is more than 1 policy
  if (isPoliciesLength && !isEditing && !isFetchingPolicies) {
    return <>{reorderButtons}</>;
  }

  // if we have no proper header to show, then use height filler
  return (<Box height="32px" />);
};

export default PolicyListHeader;
